import { useCallback, useEffect, useState } from 'react'
import { GET_LIST, useClient } from '@peracto/client'

const useCategories = () => {
    const { client } = useClient()
    const [categories, setCategories] = useState(null)
    const [error, setError] = useState(null)

    const load = useCallback(async () => {
        try {
            const { data } = await client(GET_LIST, 'vehicle-categories', { filter: { pagination: false } })
            setCategories(data)
        } catch (e) {
            setError(e)
        }
    }, [client])

    useEffect(() => {
        load()
    }, [load])

    return { categories, error, reload: load }
}

export default useCategories
